{
  "fontSizeBase": "16px",
  "colorNeutral15": "#D8D8D8",
  "colorNeutral20": "#DBD7D3",
  "colorNeutral30": "#B2B2B2",
  "colorNeutral40": "#90969A",
  "colorNeutral60": "#5E666B",
  "colorNeutral80": "#2F3A40",
  "colorNeutralDefault": "#001219",
  "colorNeutralWhite": "#FFFFFF",
  "colorNeutral02": "#FBFBFB",
  "colorNeutral03": "#F6F7F7",
  "colorNeutral05": "#F2F2F2",
  "colorBrand1Active": "#003242",
  "colorBrand1Base": "#004455",
  "colorBrand1Hover": "#255564",
  "colorBrand1Tint": "#F2F5F6",
  "colorBrand1Highlight": "#DAE3E6",
  "colorBrand2Active": "#F67748",
  "colorBrand2Base": "#F99F7E",
  "colorBrand2Hover": "#FAB297",
  "colorBrand2Tint": "#FFF5F2",
  "colorActionActive": "#085073",
  "colorActionBase": "#117EAC",
  "colorActionHover": "#63B2D3",
  "colorActionTint": "#F9FAFD",
  "colorMessageSuccessBase": "#048106",
  "colorMessageSuccessHover": "#006900",
  "colorMessageSuccessTint": "#F8FBF7",
  "colorMessageWarningBase": "#FCBF38",
  "colorMessageWarningHover": "#E2B027",
  "colorMessageWarningTint": "#FFFDF9",
  "colorMessageErrorBase": "#B93646",
  "colorMessageErrorHover": "#FCEDED",
  "colorMessageErrorTint": "#FEF9F9",
  "colorDecPurple10": "#f0e9f4",
  "colorDecPurple15": "#ebe4f0",
  "colorDecPurple100": "#ba8ecc",
  "colorDecPurple150": "#4e3b5e",
  "colorDecTurquoise10": "#d7e9eb",
  "colorDecTurquoise20": "#bad6de",
  "colorDecTurquoise30": "#98c4cb",
  "colorDecTurquoise40": "#6ba8ad",
  "colorDecTurquoise60": "#007a84",
  "colorDecTurquoise80": "#007a85",
  "colorDecTurquoise100": "#005d66",
  "colorDecTurquoise03": "#f2fafc",
  "colorDecTurquoise05": "#e5f0f1",
  "colorDecIndigo05": "#f3f4f9",
  "colorDecIndigo10": "#e7e9f4",
  "colorDecIndigo15": "#dfe1ef",
  "colorDecIndigo30": "#c5c9e1",
  "colorDecIndigo50": "#6069a8",
  "colorDecIndigo60": "#4c5693",
  "colorDecIndigo80": "#38427f",
  "colorDecIndigo100": "#818ece",
  "colorDecIndigo200": "#565F82",
  "colorDecBlue10": "#d6e4ef",
  "colorDecBlue15": "#e2edf3",
  "colorDecBlue100": "#326eb1",
  "colorDecCyan10": "#d0eef3",
  "colorDecCyan100": "#23accb",
  "colorDecKelly03": "#e3edec",
  "colorDecKelly10": "#c8f0e8",
  "colorDecKelly100": "#0fb689",
  "colorDecGreen10": "#e7f3f0",
  "colorDecGreen15": "#d8ece7",
  "colorDecGreen30": "#77bba9",
  "colorDecGreen50": "#088463",
  "colorDecGreen60": "#00664b",
  "colorDecGreen100": "#4BA039",
  "colorDecYellow02": "#FFFBF5",
  "colorDecYellow03": "#f5f0e8",
  "colorDecYellow10": "#faf2d4",
  "colorDecYellow15": "#fef0cf",
  "colorDecYellow60": "#fcbf38",
  "colorDecYellow40": "#f1d77d",
  "colorDecYellow100": "#eec331",
  "colorDecOrange10": "#fae1cd",
  "colorDecOrange100": "#eb561d",
  "colorDecRed10": "#fadddb",
  "colorDecRed15": "#f5e0dc",
  "colorDecRed60": "#be4025",
  "colorDecRed70": "#982c0e",
  "colorDecRed100": "#e9453e",
  "colorDecBrown100": "#8e4f17",
  "colorDecBlack30": "#161616",
  "colorDecSandElevationMinus1": "#e7dbd0",
  "colorDecSandElevation0": "#f3eee9",
  "colorDecSandElevation1": "#fdfbf7",
  "colorDecSandElevation2": "#fffefd",
  "colorAccessibilityFocusDefault": "#009ea8",
  "colorNeutral700": "#495265",
  "colorNeutral800": "#363E4E",
  "colorNeutral900": "#242B38",
  "colorNeutral950": "#111416",
  "colorNeutralBlack": "#000000",
  "colorSand100": "#FDFBF7",
  "colorSand200": "#F3EEE9",
  "colorSand300": "#E7DBD0",
  "colorSand600": "#685F57",
  "colorSand800": "#332D26",
  "colorTerra50": "#F8F1EB",
  "colorTerra100": "#F5EAE1",
  "colorTerra300": "#E9D0BD",
  "colorTerra700": "#8E4F17",
  "colorTerra800": "#5F310F",
  "colorTeal100": "#D7E9EB",
  "colorTeal200": "#BAD6DE",
  "colorTeal800": "#003242",
  "colorBlue100": "#D6E4EF",
  "colorBlue200": "#A6C2DB",
  "colorBlue300": "#79A2C8",
  "colorBlue600": "#185998",
  "colorIndigo100": "#E7E9F4",
  "colorIndigo600": "#4C5693",
  "colorIndigo700": "#38427F",
  "colorGreen200": "#A6CFBE",
  "colorGreen500": "#088463",
  "colorGreen600": "#006A4A",
  "colorGreen700": "#005134",
  "colorYellow700": "#AC7600",
  "colorYellow800": "#825601",
  "colorWarningDark": "#AD6E00",
  "colorRed700": "#7B1500",
  "colorTextPrimary": "#242B38",
  "colorTextPrimaryDefault": "#4C5693",
  "colorTextSecondary": "#5F6777",
  "colorTextNeutralSecondary": "#5E666B",
  "colorTextNeutralDisabled": "#B2B2B2",
  "colorTextWarningDefault": "#825601",
  "colorTextNegativeDefault": "#7B1500",
  "colorMainAction": "#0D6A97",
  "colorInteractivePrimary": "#326BDC",
  "elevation01": "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
  "elevation04": "0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)",
  "elevation08": "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.2)",
  "dropShadow01": "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
  "dropShadow02": "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10)",
  "dropShadow03": "0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)",
  "dropShadow04": "0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10)",
  "dropShadow05": "0px 20px 25px -5px rgba(0, 0, 0, 0.10), 0 8px 10px -6px rgba(0, 0, 0, 0.10)",
  "dropShadow06": "0px 25px 50px -12px rgba(0, 0, 0, 0.25)",
  "dropShadow07": "0px 25px 50px 0px rgba(0, 0, 0, 0.08)",
  "innerShadow01": "0 2px 4px 0 rgba(0, 0, 0, 0.05) inset",
  "spacing00": "0px",
  "spacing01": "0.25rem",
  "spacing02": "0.5rem",
  "spacing03": "1rem",
  "spacing04": "1.5rem",
  "spacing05": "2rem",
  "spacing06": "2.5rem",
  "spacing07": "3rem",
  "spacing08": "3.5rem",
  "fontFamilyInclusiveSans": "Inclusive Sans",
  "fontFamilyLora": "lora",
  "fontFamilyFallback": "Arial",
  "fontLetterSpacing00": "normal",
  "fontLetterSpacing01": "0.005em",
  "fontLetterSpacing02": "0.01em",
  "fontLetterSpacing03": "0.0125em",
  "fontLetterSpacing04": "0.0325em",
  "fontLineHeight10": "3.5rem",
  "fontLineHeight01": "0.875rem",
  "fontLineHeight02": "1rem",
  "fontLineHeight03": "1.125rem",
  "fontLineHeight04": "1.25rem",
  "fontLineHeight05": "1.375rem",
  "fontLineHeight06": "1.5rem",
  "fontLineHeight07": "1.75rem",
  "fontLineHeight08": "2rem",
  "fontLineHeight09": "2.25rem",
  "fontSize01": "0.625rem",
  "fontSize02": "0.75rem",
  "fontSize03": "0.875rem",
  "fontSize04": "1rem",
  "fontSize05": "1.125rem",
  "fontSize06": "1.25rem",
  "fontSize07": "1.5rem",
  "fontSize08": "1.75rem",
  "fontSize09": "2.25rem",
  "fontSize10": "3rem",
  "fontWeightLight": "300",
  "fontWeightNormal": "400",
  "fontWeightMedium": "500",
  "fontWeightSemibold": "600",
  "fontWeightBold": "700",
  "breakpointXs": "599px",
  "breakpointSm": "959px",
  "breakpointTablet": "1149px",
  "breakpointMd": "1439px",
  "breakpointLg": "1919px",
  "mediaQueryExpressionAll": "all",
  "mediaQueryExpressionPrint": "print",
  "mediaQueryExpressionScreen": "screen",
  "mediaQueryExpressionSpeech": "speech",
  "mediaQueryExpressionLandscape": "'(orientation: landscape)'",
  "mediaQueryExpressionPortrait": "'(orientation: portrait)'",
  "mediaQueryUnitIntervalsPx": "1",
  "mediaQueryUnitIntervalsEm": "0.01",
  "mediaQueryUnitIntervalsRem": "0.1",
  "borderRadius00": "0",
  "borderRadius01": "0.125rem",
  "borderRadius02": "0.25rem",
  "borderRadius03": "0.5rem",
  "borderRadius04": "1rem",
  "borderRadius045": "1.25rem",
  "borderRadius05": "1.5rem",
  "borderRadius06": "2rem",
  "borderRadiusFull": "50%"
}